if (!customElements.get('cube-quantity-offer')) {
  customElements.define('cube-quantity-offer', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info');
      this.input = this.scope?.querySelector('input[name="quantity"]');
      this.nativeQuantity = this.input?.closest('.product-form__quantity');
      if (!this.input || !this.nativeQuantity || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.buttons = [...this.querySelectorAll('[data-quantity]')];
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency', currency: this.dataset.currency
      });
      this.other = this.querySelector('[data-other-quantity]');
      this.other.setAttribute('aria-controls', this.nativeQuantity.id);
      this.buttons.forEach(button => button.addEventListener('click', () => {
        this.input.value = button.dataset.quantity;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
        this.nativeQuantity.hidden = true;
        this.other.setAttribute('aria-expanded', 'false');
      }, options));
      this.other.addEventListener('click', () => {
        this.nativeQuantity.hidden = !this.nativeQuantity.hidden;
        this.other.setAttribute('aria-expanded', String(!this.nativeQuantity.hidden));
        if (!this.nativeQuantity.hidden) this.input.focus();
      }, options);
      this.input.addEventListener('change', () => this.sync(), options);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.input, { attributes: true, attributeFilter: ['min', 'max', 'step'] });
      this.nativeQuantity.hidden = true;
      this.sync();
      this.hidden = false;
    }
    sync() {
      const quantity = Number(this.input.value);
      const min = Number(this.input.min) || 1;
      const max = this.input.max ? Number(this.input.max) : Infinity;
      const step = Number(this.input.step) || 1;
      this.buttons.forEach(button => {
        const value = Number(button.dataset.quantity);
        button.disabled = value < min || value > max || (value - min) % step !== 0;
        button.setAttribute('aria-pressed', String(quantity === value));
      });
      const valid = Number.isInteger(quantity) && quantity >= min && quantity <= max && (quantity - min) % step === 0;
      this.querySelector('[data-quantity-label]').textContent = valid ? `${quantity} cube${quantity > 1 ? 's' : ''}` : 'Choisissez une quantité';
      this.querySelector('[data-cb-quantity-total]').textContent = valid ? this.format.format(Number(this.dataset.unitPrice) * quantity / 100) : '—';
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      if (this.nativeQuantity) this.nativeQuantity.hidden = false;
      this.controller = null;
    }
  });
}
